// src/data/achievementsData.js
const achievementsData = {
  achievement0: {
    name: "Angel Investor",
    description: "Upgrade your trader level."
  },
  achievement1: {
    name: "Due Diligence",
    description: "View a company's chart for the first time."
  },
  achievement2: {
    name: "Team Player",
    description: "Join a company."
  },
  achievement3: { name: "Executive Lounge", description: "Become the CEO of a company." },
  achievement4: { name: "Entrepreneurial", description: "Found a company." },
  achievement5: { name: "Market Entry", description: "Issue stock or crypto." },
  achievement6: { name: "Open Channel", description: "Send a message in Global chat." },
  achievement7: { name: "Local Line", description: "Send a message in Region chat." },
  achievement8: { name: "Direct Link", description: "Send a direct message." },
  achievement9: { name: "Protocol Access", description: "Use a PIP command." },
  achievement10: { name: "Struck Gold", description: "Mint 100 gold units." },
  achievement11: { name: "Goldsmith", description: "Mint 1,000 gold units." },
  achievement12: { name: "Heavy Mint", description: "Mint 25,000 gold units." },
  achievement13: { name: "First Check-In", description: "Claim a daily reward." },
  achievement14: { name: "Regular Return", description: "Claim 10 daily rewards." },
  achievement15: { name: "Daily Discipline", description: "Claim 100 daily rewards." },
  achievement16: { name: "Windfall", description: "Get a lucky daily reward." },
  achievement17: { name: "Bonanza", description: "Win a jackpot." },
  achievement18: { name: "Starter Share", description: "Give a trader a tip." },
  achievement19: { name: "Supporter", description: "Give $10,000.00 in tips." },
  achievement20: { name: "Contributor", description: "Give $25,000.00 in tips." },
  achievement21: { name: "Backer", description: "Give $100,000.00 in tips." },
  achievement22: { name: "Millionaire's Club", description: "Reach $1,000,000.00 portfolio value." },
  achievement23: { name: "In the Green", description: "Reach $1.00 in gains." },
  achievement24: { name: "Steady Climb", description: "Reach $10,000.00 in gains." },
  achievement25: { name: "Bull Run", description: "Reach $100,000.00 in gains." },
  achievement26: { name: "Market Leader", description: "Reach $1,000,000.00 in gains." },
  achievement27: { name: "Diversified", description: "Hold at least one of each of the following instruments: stock, crypto, forex, gold, bonds, and futures." },
  achievement28: { name: "First Exchange", description: "Exchange $1.00." },
  achievement29: { name: "Currency Mover", description: "Exchange $1,000.00." },
  achievement30: { name: "Global Trader", description: "Exchange $10,000.00." },
  achievement31: { name: "Forex Specialist", description: "Exchange $100,000.00." },
  achievement32: { name: "Position Opened", description: "Purchase a futures contract." },
  achievement33: { name: "Closed in the Green", description: "Profit off a futures contract." },
  achievement34: { name: "Forward Thinker", description: "Profit $10,000.00 off a futures contract." },
  achievement35: { name: "Futures Specialist", description: "Profit $100,000.00 off a futures contract." },
  achievement36: { name: "Asset Acquired", description: "Collect 1 item." },
  achievement37: { name: "Stockpile", description: "Collect 10 items." },
  achievement38: { name: "Wholesale", description: "Collect 100 items." },
  achievement39: { name: "Supply Chain Monopoly", description: "Collect 1,000 items." },
  achievement40: { name: "Terms & Conditions", description: "Create a contract." },
  achievement41: { name: "Executor", description: "Accept a contract." },
  achievement42: { name: "Recruiter", description: "Refer a trader." },
  achievement43: { name: "Networker", description: "Refer 10 traders." },
  achievement44: { name: "Kickback Scheme", description: "$1,000.00 in residual income." },
  achievement45: { name: "Multi-Level Marketing", description: "$10,000.00 in residual income." }
};

export default achievementsData;
